import { defineModel } from "../define-model";
import type { SocialPlatform } from "./social-account";

export type MetricValues = {
	impressions?: number | null;
	reach?: number | null;
	views?: number | null;
	likes?: number | null;
	comments?: number | null;
	shares?: number | null;
	saves?: number | null;
	clicks?: number | null;
	/** Percent, e.g. 4.25 = 4.25%. */
	engagementRate?: number | null;
};

export type PostTarget = {
	id: string;
	workspaceId: string;
	projectId: string | null;
	postId: string;
	socialAccountId: string;
	platform: SocialPlatform;
	status: "pending" | "publishing" | "published" | "failed";
	platformOptions: { caption?: string; firstComment?: string };
	platformPostId: string | null;
	platformPostUrl: string | null;
	publishedAt: string | null;
	error: string | null;
	latestMetrics: MetricValues | null;
	/** Last metrics check (values may be unchanged since). */
	metricsUpdatedAt: string | null;
	commentsSyncedAt: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		postTarget: PostTarget;
	}
}

export const model = defineModel({
	name: "postTarget",
	load: "lazy",
	indexes: ["postId", "projectId"],
	sort: (a, b) => a.platform.localeCompare(b.platform),
});
